import styled from '@emotion/styled';
import { media } from '../../../services/media';

import React from 'react';
import { Bar } from './Bar';

export const MenuTrigger: React.FC<any> = ({ onClick }) => {
    return (
        <Button type="button" onClick={onClick}>
            <Bar />
            <Bar />
            <Bar />
        </Button>
    );
};

const Button = styled.button`
    display: block;

    width: 29px;
    height: 16px;
    padding: 0;

    position: relative;

    border: 0;
    background-color: transparent;
    cursor: pointer;

    ${media.min('md')} {
        width: 45px;
        height: 25px;
    }

    ${media.min('lg')} {
        width: 65px;
        height: 37px;
    }
`;
